function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 78,
  cy: 73,
  r: 73,
  fill: "#FFEAE3"
});

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 78.5,
  cy: 74.5,
  r: 56.5,
  fill: "#FC8C66"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M78.5361 109H78.4639C52.7949 109 48 99.0812 48 99.0812C48 80.2859 65.0887 73.4578 73.7051 71.3016C67.6483 68.8937 64.9444 64.6172 64.9444 56.5312C64.9444 46.4328 70.0999 40 78.5 40C86.9001 40 92.0556 46.4328 92.0556 56.5312C92.0556 64.6172 89.3517 68.8578 83.2949 71.2656C91.9113 73.4578 109 80.25 109 99.0453C109 99.0812 104.782 109 78.5361 109Z",
  fill: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  x: 7,
  y: 157,
  width: 22,
  height: 22,
  rx: 3,
  fill: "#FC8C66"
});

var _ref6 = /*#__PURE__*/React.createElement("rect", {
  x: 1,
  y: 150,
  width: 35,
  height: 35,
  rx: 2,
  stroke: "#FC8C66",
  strokeWidth: 2
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M120 158H48V155H120V158Z",
  fill: "#FC8C66"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M100 169.69H48V167H100V169.69Z",
  fill: "#FC8C66"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M113.5 181H48V178H113.5V181Z",
  fill: "#FC8C66"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M151.555 115.308C151.181 114.935 150.637 114.901 150.297 115.206L120.731 144.774L118.012 154.901C117.91 155.479 118.488 156.091 119.099 155.989L129.227 153.27L158.794 123.703C159.099 123.397 159.065 122.819 158.692 122.445L151.555 115.308Z",
  fill: "#FC8C66"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M164.676 116.119L157.905 109.299C157.506 108.9 156.842 108.9 156.411 109.299L153.124 112.593C152.959 112.759 152.959 113.058 153.124 113.225L160.759 120.875C160.925 121.042 161.224 121.042 161.39 120.875L164.676 117.582C165.108 117.183 165.108 116.518 164.676 116.119Z",
  fill: "#FC8C66"
});

var SvgProfile = function SvgProfile(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 165,
    height: 186,
    viewBox: "0 0 165 186",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgProfile, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/profile.cd78710f.svg";
export { ForwardRef as ReactComponent };